import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Service Worker 등록 (푸시 알림을 위해 활성화)
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/service-worker.js')
      .then((registration) => {
        console.log('Service Worker 등록 성공:', registration.scope);
        
        registration.onupdatefound = () => {
          const installingWorker = registration.installing;
          if (installingWorker == null) {
            return;
          }
          installingWorker.onstatechange = () => {
            if (installingWorker.state === 'installed') {
              if (navigator.serviceWorker.controller) {
                console.log('새로운 콘텐츠가 있으며 모든 탭이 닫히면 사용됩니다.');
                // 업데이트 알림을 표시하기 위해 이벤트를 전달합니다.
                window.dispatchEvent(new CustomEvent('newVersionAvailable'));
              } else {
                console.log('콘텐츠가 오프라인 사용을 위해 캐시되었습니다.');
              }
            }
          };
        };
      })
      .catch((error) => {
        console.log('Service Worker 등록 실패:', error);
      });
  });
}

// 앱 설치 프롬프트
// eslint-disable-next-line no-unused-vars
let deferredPrompt;

window.addEventListener('beforeinstallprompt', (e) => {
  e.preventDefault();
  deferredPrompt = e;

  // 사용자에게 설치 안내 표시 (선택사항)
  console.log('앱 설치 가능');
});

window.addEventListener('appinstalled', () => {
  console.log('앱이 설치되었습니다');
  deferredPrompt = null;
});

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
